<igo-map-browser [map]="map"></igo-map-browser>
<ng-container *ngIf="isLoading">
  <h1>Récupération des données... {{nbCouches}}/{{totalCouches}}</h1>
</ng-container>
<app-fiche-descriptive-table
  *ngFor="let entry of listeDesTables"
  [ficheDescriptiveOptions]="entry"
  (dataLoaded)="onDataLoaded()">
</app-fiche-descriptive-table>
